'use client';

import dayjs from 'dayjs';
import dynamic from 'next/dynamic';
import { memo, useEffect, useState } from 'react';
import type { Data as RegistrationData } from '../../../../../quick-services/ActivitiesPublicRegistrationPage';
import type { IProps } from './appShare';

const AppShare = dynamic(() => import('./appShare'), { ssr: false });

// 过滤表情包
const checkValue = (val: string | undefined) => {
  if (!val) {
    return '';
  }
  const pattern = /\ud83c[\udc00-\udfff]|\ud83d[\udc00-\udfff]|[\u2000-\u2fff]/g;
  const value = val.replace(pattern, '');
  return value;
};

const LOGO_URL = 'https://cdn.calendar.tencent.com/calendar_res/activity/color-logo.png';

export const getShareData = (eventId: string, data: RegistrationData): IProps => {
  const eventInfo = data.activity_basic_info;
  const shareUrl =
    typeof window === 'undefined'
      ? `https://meeting.tencent.com/events/host/event/${eventId}/registration`
      : window.location.href;

  const { start_time: startTime = '', end_time: endTime = '' } = data.activity_basic_info;
  let desc = '';
  if (startTime !== '' && endTime !== '') {
    const startDate = dayjs(Number(startTime) * 1000);
    const endDate = dayjs(Number(endTime) * 1000);
    const startFormat = startDate.format('YYYY/MM/DD HH:mm');
    const endFormat = endDate.format('YYYY/MM/DD HH:mm');
    desc = `活动时间：${startFormat} - ${endFormat}`;
    const now = dayjs();
    if (startDate.isAfter(now)) {
      desc += '点击查看活动详情';
    }
    if (startDate.isBefore(now) && endDate.isAfter(now)) {
      desc += '\r\n活动进行中，尽快加入活动';
    }
    if (endDate.isBefore(now)) {
      desc = '活动已结束，点击查看详情或观看回放。';
    }
  }

  let imgUrl = data.activity_basic_info.background_urls[0];
  if (imgUrl) {
    imgUrl = `${imgUrl}&imageMogr2/thumbnail/192x/quality/90`;
  }
  const imageUrl = imgUrl || LOGO_URL; // 这里记得请求小图，否则分享会报错
  return {
    shareTitle: checkValue(eventInfo?.title) || '腾讯会议·活动',
    shareDesc: desc, // 活动时间
    shareUrl,
    shareImageUrl: imageUrl,
  };
};

const Client = (props: IProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }
  return <AppShare {...props} />;
};

export default memo(Client);
